import * as tslib_1 from "tslib";
import { ReferenceField } from './reference_field';
var Select = /** @class */ (function (_super) {
    tslib_1.__extends(Select, _super);
    function Select(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'mulitSelect';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    Select.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "Select",
            "mulitSelect": this.mulitSelect
        });
    };
    Select.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Select;
}(ReferenceField));
export { Select };
//# sourceMappingURL=select.js.map